module.exports = __webpack_public_path__ + "static/img/arrow-down.bd6dcce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.png
// module id = jIOt
// module chunks = 1